import type { AccountReferralData } from "@/types/account";
import Bugsnag from "@bugsnag/js";

export function maybeBackupReferralQueryParams() {
  try {
    if (typeof window === "undefined") return null;
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    if (
      !params.has("utm_source") &&
      !params.has("utm_medium") &&
      !params.has("utm_campaign") &&
      !params.has("utm_id") &&
      !params.has("referral")
    ) {
      return;
    }
    const data = {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_id: params.get("utm_id"),
      referral: params.get("referral"),
    };

    localStorage.setItem("referralData", encodeURIComponent(btoa(JSON.stringify(data))));
  } catch (e) {
    if (Bugsnag.isStarted()) {
      Bugsnag.notify(e as Error);
    }
  }
}

export function parseReferralData(encodedData: string): AccountReferralData | null {
  try {
    const decodedData = atob(decodeURIComponent(encodedData));
    if (!decodedData) return null;
    const parsedData = JSON.parse(decodedData);
    if ((!parsedData?.utm_id || !parsedData?.utm_source) && !parsedData?.referral)
      return null;
    return parsedData;
  } catch (error) {
    console.error("Failed to decode referral data:", error);
    return null;
  }
}
